// apps/spa/src/routes/Login.tsx
// Charter-style showcase login: ambient starfield backdrop, glow-ring brand mark,
// editorial Fraunces heading, italic gold tagline, shimmer Discord CTA.
//
// The CTA is a real <a> (NOT React Router <Link>) so the click hits Pages
// Functions at /api/auth/start, not the SPA router. After OAuth, callback
// redirects to '/' which RouteGuard resolves to /reminders.

import { motion, useReducedMotion } from 'motion/react';
import { AmbientBackground } from '@/components/visual/AmbientBackground';
import { GlowRing } from '@/components/visual/GlowRing';
import { staggerContainer, staggerItem } from '@/lib/motion';

export function Login() {
  const reduce = useReducedMotion();
  return (
    <div className="relative min-h-screen flex items-center justify-center px-4 text-foreground">
      <AmbientBackground variant="full" />
      <motion.div
        variants={staggerContainer}
        initial={reduce ? false : 'hidden'}
        animate="show"
        className="glass w-full max-w-md p-10 text-center"
      >
        <motion.div variants={staggerItem} className="mb-6 flex justify-center">
          <GlowRing size={132}>
            <img
              src="/idle_smooth.gif"
              alt=""
              aria-hidden="true"
              width={1141}
              height={570}
              loading="eager"
              className="h-full w-full object-cover"
            />
          </GlowRing>
        </motion.div>
        <motion.h1
          variants={staggerItem}
          className="font-display text-5xl font-medium tracking-tight text-heading"
        >
          Guardian
        </motion.h1>
        <motion.p
          variants={staggerItem}
          className="mt-2 font-display italic text-primary/90"
        >
          BASTN Officer Tools
        </motion.p>
        <motion.a
          variants={staggerItem}
          href="/api/auth/start"
          className="shimmer-sweep mt-8 inline-flex items-center justify-center rounded-lg bg-primary px-6 py-3 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
        >
          Login with Discord
        </motion.a>
      </motion.div>
    </div>
  );
}
